import { urlApiTegra, get, post, put } from "../../../../../service/api";

const url = urlApiTegra;

const getImmobilized = (token: any) => {
  return get(`${url}/furniture-inventory`, token);
};

const getImmobilizedById = (id: string | number, token: any) => {
  return get(`${url}/furniture-inventory/${id}`, token);
};

const postImmobilized = (body: any, token: any) => {
  return post(`${url}/furniture-inventory`, body, token);
};

const putImmobilized = (id: string | number, body: any, token: any) => {
  return put(`${url}/furniture-inventory/${id}`, body, token);
};


const getImmobilizedFilter = (token: string, queryString?: string) => {
  return get(queryString ? `${urlApiTegra}/furniture-inventory${queryString}` : `${urlApiTegra}/furniture-inventory`, token);
};

export { getImmobilized, getImmobilizedById, postImmobilized, putImmobilized, getImmobilizedFilter };
